import { createRoot } from 'react-dom/client';
import moment from 'moment';
import './styles/index.scss';
import Root from './Root';
import { Provider } from 'react-redux';
import { saveState } from './services/localStorage';
import { saveSessionState } from './services/sessionStorage';
import configureStore from './store';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import metadata from './metadata.json';
import { CURRENT_ENV } from './constants';
import { currentLocale } from './i18n';

const env = import.meta.env.VITE_API_ENV || CURRENT_ENV;

Sentry.init({
  dsn: 'https://2b2918cbcc13244add88abf6f621fa32@o4507094863839232.ingest.de.sentry.io/4510283133485136',
  release: 'accumbo-admin@' + metadata.version,
  environment: env,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: env === 'production' ? 0.01 : 0.1,
  normalizeDepth: 2,
  ignoreErrors: [
    'Failed to fetch',
    'An error occurred while fetching the data',
    'BodyStreamBuffer was aborted',
    /SSE response code: \d+/,
    'network error',
    'Network Error',
    'Load failed',
    'NetworkError',
    'The network connection was lost',
    'The Internet connection appears to be offline'
  ]
});

const store = configureStore();

store.subscribe(() => {
  const locale = 'sv';
  saveSessionState(store.getState().auth, 'auth');

  if (currentLocale() !== locale) {
    saveState(locale, 'locale');
    moment.locale(locale);
  }
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <Root />
  </Provider>
);
